/**
 * notifyPromise - send custom notification event with the success/error result of a promise.
 *
 * This allows MessageAlert and MessageFormGroup to automatically display success/failures.
 *
 * @param {*} promise
 * @param {*} success -- success message massager
 * @param {*} error -- error message massager
 */
export default function notifyPromise(path, promise, success, error) {
  return promise.then(
    result => dispatch(path, 'success', result, success),
    e => dispatch(path, 'error', e, error),
  );
}

function dispatch(path, type, obj, massager) {
  let message = massageMessage(obj, massager);
  let messageEvent = new CustomEvent('notification', {detail: {message, type}, bubbles: true});
  let target = path.find(d => d.isConnected);
  // Target should always be something since path will go all the way up to 'body'
  target.dispatchEvent(messageEvent);
  console.log('Event dispatched', target, messageEvent);
}

function massageMessage(value, massager) {
  if (typeof massager === "string") {
    return massager;
  }
  if (typeof massager === "function") {
    return massager(value);
  }
  if (value instanceof Error) {
    console.error(value);
    return value.message;
  }
  if (massager !== undefined) {
    console.warn(`Didn't know how to massage message ${JSON.stringify(message)} using ${JSON.stringify(massager)}`);
  }
  return value;
}



// WEBPACK FOOTER //
// ./src/lib/bubble/notifyPromise.js